import type { LocationState } from 'redux-first-router';
import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import type { People } from '@ducks/people/reducers';
import { separateByThreeDigit } from '@simplywallst/formatting';
import { pathConstructor } from '@/hooks/useCompany/utils';

interface State {
  location: LocationState;
  company: CompanyState;
  people: Record<string, People>;
}
interface Selected {
  founded: string;
  employees: string;
  ceo: string;
  industry: string;
  website?: string;
  description: string;
}

const selector = (state: State): Selected | undefined => {
  try {
    const path = pathConstructor(state.location);
    const companyId = state.company.urlToIdMapping[path];
    const summary = state.company.summary[companyId];
    const management = state.company.management[companyId];
    const analysis = state.company.analysis[companyId];
    let ceoName = 'n/a';
    if (management.leaderId !== '') {
      const ceo = state.people[management.leaderId];
      ceoName = `${ceo.salutation} ${ceo.lastName}`;
    }
    let yearFounded = 'n/a';
    if (!isNaN(summary.yearFounded)) {
      yearFounded = summary.yearFounded.toString();
    }
    return {
      founded: yearFounded,
      employees:
        typeof analysis?.totalEmployees === 'number'
          ? separateByThreeDigit(analysis?.totalEmployees)
          : 'n/a',
      industry: summary.industryData.primaryName,
      ceo: ceoName,
      website: summary.website,
      description: summary.description,
    };
  } catch {
    return undefined;
  }
};
export default selector;
